// import { useEffect, useState } from 'react';
// import PausedStudentsTable from '../Sheet/PausedStudentsTable';

// const SelectClass = ({
//   setDisable,
//   loading,
//   classData,
//   setClassData,
//   courses,
//   clearAttendance,
//   loadingCourses,
//   currentStep,
//   disable,
//   handleNext,
//   handleBack,
// }) => {
//   console.log(currentStep, 'currentStep');
//   const [errors, setErrors] = useState([]);

//   const [batches, setBatches] = useState([]);

//   const handleCourseChange = (event) => {
//     const courseId = event.target.value;
//     const selectedCourse = courses.find(
//       (course) => course.courseId === courseId
//     );
//     setBatches(selectedCourse?.batches || []);
//     setClassData({ ...classData, courseId, batchId: '' });
//     clearAttendance();
//   };

//   const handleBatchChange = (event) => {
//     const batchId = event.target.value;
//     setClassData({ ...classData, batchId });
//     clearAttendance();
//   };

//   useEffect(() => {
//     if (classData.courseId) {
//       const selectedCourse = courses.find(
//         (course) => course.courseId === classData.courseId
//       );
//       setBatches(selectedCourse?.batches || []);
//     }
//   }, [classData.courseId, courses]);

//   useEffect(() => {
//     const newErrors = [];
//     if (!classData?.courseId.trim() || !classData?.batchId.trim()) {
//       newErrors.push('Please fill in all fields.');
//     }
//     setErrors(newErrors);
//     setDisable(newErrors.length > 0);
//   }, [classData, setDisable]);

//   return (
//     <div className="w-full rounded-lg px-3 pt-7 md:px-8">
//       {/* Header */}
//       <div className="flex justify-center">
//         <h4 className="text-lg font-bold text-navy-700 dark:text-white">
//           Select Class Information
//         </h4>
//       </div>
//       {loading && (
//         <div className="mt-4 text-center">
//           <span>Loading...</span>
//         </div>
//       )}

//       {/* Course Select */}
//       <div className="mb-10 mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
//         <div className="w-full md:w-1/2">
//           <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//             Select Course
//           </label>
//           <select
//             onChange={handleCourseChange}
//             value={classData?.courseId}
//             name="course"
//             disabled={loading}
//             className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//           >
//             <option value="">Click here to Select Course</option>
//             {loadingCourses ? (
//               <option>Loading courses...</option>
//             ) : (
//               <>
//                 {courses.map((course, i) => (
//                   <option key={course.courseId} value={course.courseId}>
//                     {i + 1}. {course.courseName}
//                   </option>
//                 ))}
//               </>
//             )}
//           </select>
//         </div>

//         {/* Batch Select */}
//         <div className="w-full md:w-1/2">
//           <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//             Select Batch
//           </label>
//           <select
//             onChange={handleBatchChange}
//             value={classData?.batchId}
//             name="batch"
//             className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//           >
//             <option value="">Click here to Select Batch</option>
//             {loading ? (
//               <option>Loading batches...</option>
//             ) : batches.length > 0 ? (
//               batches.map((batch) => {
//                 // Extract unique times from daySchedules
//                 const times = batch.daySchedules
//                   ?.map((ds) => ds.startTime)
//                   .filter(Boolean);
//                 const uniqueTimes = [...new Set(times)]; // remove duplicates
//                 const timeDisplay =
//                   uniqueTimes.length > 0
//                     ? ` at ${uniqueTimes.join(' / ')}`
//                     : '';

//                 return (
//                   <option key={batch._id} value={batch._id}>
//                     Batch {batch.batchNumber} - From{' '}
//                     {new Date(batch.startDate).toLocaleDateString()}
//                     to {new Date(batch.endDate).toLocaleDateString()}
//                     {timeDisplay}
//                   </option>
//                 );
//               })
//             ) : (
//               <option>No batches available</option>
//             )}
//           </select>
//         </div>
//       </div>

//       {/* Display errors */}
//       {errors.length > 0 && (
//         <div className="-mt-8 mb-6 text-red-500">
//           {errors.map((error, index) => (
//             <p key={index}>{error}</p>
//           ))}
//         </div>
//       )}

//       {currentStep === 1 ? (
//         <div className="mb-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
//           <button
//             disabled={disable}
//             onClick={handleNext}
//             className=" linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
//           >
//             {loading ? 'Loading..' : 'Next'}
//           </button>
//         </div>
//       ) : (
//         <div className="flex flex-col justify-between px-3 pt-2  md:flex-row md:px-8">
//           <button
//             onClick={handleBack}
//             className={`mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0`}
//           >
//             Prev
//           </button>
//         </div>
//       )}

//       <PausedStudentsTable className="mt-10" classData={classData} />
//     </div>
//   );
// };

// export default SelectClass;

import { useEffect, useState } from 'react';
import PausedStudentsTable from '../Sheet/PausedStudentsTable';

const SelectClass = ({
  setDisable,
  setLoading,
  classData,
  setClassData,
  courses,
  batchStructures,
  fetchBatchStructures,
  fetchBatchesByStructure,
  clearAttendance,
  loadingCourses,
  currentStep,
  disable,
  handleNext,
  handleBack,
}) => {
  const [errors, setErrors] = useState([]);
  const [batches, setBatches] = useState([]);
  const [loadingBatches, setLoadingBatches] = useState(false);

  /* ================= COURSE CHANGE ================= */
  const handleCourseChange = async (e) => {
    const courseId = e.target.value; // ✅ Mongo _id

    setClassData({
      courseId,
      batchStructureId: '',
      batchId: '',
    });

    setBatches([]);
    clearAttendance();
    setDisable(true);

    if (courseId) {
      await fetchBatchStructures(courseId);
    }
  };

  /* ================= STRUCTURE CHANGE ================= */
  const handleStructureChange = async (e) => {
    const batchStructureId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchStructureId,
      batchId: '',
    }));

    setBatches([]);
    clearAttendance();
    setDisable(true);

    if (!batchStructureId) return;

    try {
      setLoadingBatches(true);
      const res = await fetchBatchesByStructure(batchStructureId);
      setBatches(Array.isArray(res) ? res : []);
    } catch {
      setBatches([]);
    } finally {
      setLoadingBatches(false);
    }
  };

  /* ================= BATCH CHANGE ================= */
  const handleBatchChange = (e) => {
    const batchId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchId,
    }));

    clearAttendance();
  };

  /* ================= VALIDATION ================= */
  useEffect(() => {
    const invalid =
      !classData.courseId || !classData.batchStructureId || !classData.batchId;

    setErrors(invalid ? ['Please fill in all fields.'] : []);
    setDisable(invalid);
  }, [classData, setDisable]);

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      {/* HEADER */}
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      {/* SELECTORS */}
      <div className="mb-10 mt-6 flex flex-col md:flex-row md:gap-6">
        {/* COURSE */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            value={classData.courseId}
            onChange={handleCourseChange}
            className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-3 text-sm dark:bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : (
              courses.map((course) => (
                <option key={course._id} value={course._id}>
                  {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>

        {/* STRUCTURE */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch Structure
          </label>
          <select
            value={classData.batchStructureId}
            onChange={handleStructureChange}
            disabled={!classData.courseId}
            className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-3 text-sm disabled:opacity-60 dark:bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Structure</option>
            {batchStructures.map((bs) => (
              <option key={bs._id} value={bs._id}>
                {bs.name}
              </option>
            ))}
          </select>
        </div>

        {/* BATCH */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch
          </label>
          <select
            onChange={handleBatchChange}
            value={classData.batchId}
            disabled={!classData.batchStructureId}
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">
              {loadingBatches
                ? 'Loading batches...'
                : 'Click here to Select Batch'}
            </option>

            {!loadingBatches && batches.length === 0 && (
              <option disabled>No batches available</option>
            )}

            {!loadingBatches &&
              batches.map((batch) => {
                const times =
                  batch.daySchedules
                    ?.map((ds) => ds.startTime)
                    .filter(Boolean) || [];

                const uniqueTimes = [...new Set(times)];
                const timeDisplay =
                  uniqueTimes.length > 0
                    ? ` at ${uniqueTimes.join(' / ')}`
                    : '';

                return (
                  <option key={batch._id} value={batch._id}>
                    Batch {batch.batchNumber} —{' '}
                    {new Date(batch.startDate).toLocaleDateString()} to{' '}
                    {new Date(batch.endDate).toLocaleDateString()}
                    {timeDisplay}
                  </option>
                );
              })}
          </select>
        </div>
      </div>

      {/* ERRORS */}
      {errors.length > 0 && (
        <div className="-mt-8 mb-6 text-red-500">{errors[0]}</div>
      )}

      {/* NAV BUTTONS */}
      {currentStep === 1 ? (
        <div className="mb-4 flex justify-end px-3 md:px-8">
          <button
            disabled={disable}
            onClick={handleNext}
            className="rounded-xl bg-brand-900 px-16 py-2 font-medium text-white disabled:opacity-60"
          >
            Next
          </button>
        </div>
      ) : (
        <div className="flex justify-start px-3 md:px-8">
          <button
            onClick={handleBack}
            className="rounded-xl bg-lightPrimary px-16 py-2 font-medium"
          >
            Prev
          </button>
        </div>
      )}

      {/* PAUSED STUDENTS TABLE */}
      <PausedStudentsTable className="mt-10" classData={classData} />
    </div>
  );
};

export default SelectClass;
